export const sortByField = field => {
  return (a, b) => a[field] - b[field];
};

export const sortByValue = func => {
  return (a, b) => {
    const aVal = func(a);
    const bVal = func(b);
    if (aVal === bVal) {
      return 0;
    }

    return aVal > bVal ? 1 : -1;
  };
};

export const sortByFieldDesc = field => {
  return (a, b) => b[field] - a[field];
};

export const sortBool = field => {
  return (a, b) => {
    return a[field] === b[field] ? 0 : a[field] ? -1 : 1;
  };
};

export const sortNullsLast = field => {
  return (a, b) => {
    if (a[field] === null && b[field] !== null) {
      return 1;
    } else if (a[field] !== null && b[field] === null) {
      return -1;
    } else {
      return 0;
    }
  };
};

export const sortByUpdatedAt = (a, b) => new Date(b.updated_at) - new Date(a.updated_at);

export const sortByDateField = field => {
  return (a, b) => new Date(b[field]) - new Date(a[field]);
};

export const sortByDateFieldDesc = field => {
  return (a, b) => new Date(a[field]) - new Date(b[field]);
};
